import { Directive } from '@angular/core';

@Directive({
  selector: '[mwlTextInputHighlightContainer]',
  host: {
    '[class.text-input-highlight-container]': 'true'
  }
})
export class TextInputHighlightContainerDirective {}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/text-input-highlight-container.directive.ts